"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionAssetType = void 0;
const asset_type_1 = require("../assets/asset-type");
const { StoreCommunication, Asset3d, ...rest } = asset_type_1.AssetType;
exports.CollectionAssetType = rest;
//# sourceMappingURL=collection-asset-type.js.map